import { useSyncExternalStore } from "react";

/** Media query that matches when the operating system is set to dark mode */
const DARK_MODE_QUERY = "(prefers-color-scheme: dark)";

function subscribe(listener: () => void): () => void {
  const mediaQuery = globalThis.matchMedia(DARK_MODE_QUERY);
  mediaQuery.addEventListener("change", listener);
  return () => mediaQuery.removeEventListener("change", listener);
}

function getIsSystemDark(): boolean {
  return globalThis.matchMedia(DARK_MODE_QUERY).matches;
}

/** @returns whether the operating system prefers the dark colour scheme, following live changes */
export function useIsSystemDarkMode(): boolean {
  return useSyncExternalStore(subscribe, getIsSystemDark);
}
